export default __webpack_public_path__ + "static/media/required.a0382794.svg";